import * as React from "react";

const fields  =  {

        config: { columns: 1 },
        fields: [
            {
                name: "headOk",
                label: "visualVerification.head",
                column: 1,
                defaultValue: "true",

                type: "radio"
            }, {
                name: "stemOk",
                label: "visualVerification.stem",
                column: 1,
                defaultValue: "true",

                type: "radio"
            }, {
                name: "tipOk",
                label: "visualVerification.tip",
                column: 1,
                defaultValue: "true",

                type: "radio"
            }


        ]


    };

export default fields;